export default {
  data() {
    return {
      apartments: [],
      currentPage: 1,
      perPage: 5,
      filters: {
        hideSold: false,
        rooms: [],
        budget: [0, 10000000],
        area: [0, 500],
      },
    }
  },
  async mounted() {
    if (!window.apartmentsPath) return

    const res = await fetch(window.apartmentsPath)
    const json = await res.json()

    this.apartments = json
  },
  computed: {
    lastDisplayedIndex() {
      return this.perPage * this.currentPage
    },
    filteredApartments() {
      const [minBudget, maxBudget] = this.filters.budget
      const [minArea, maxArea] = this.filters.area

      return this.apartments.filter(a => {
        const soldFilter = !this.filters?.hideSold || !a.isSold
        const roomFilter =
          !this.filters?.rooms?.length || this.filters.rooms.includes(a.rooms)
        const budgetFilter = minBudget <= a.price && a.price <= maxBudget
        const areaFilter = minArea <= a.surface && a.surface <= maxArea

        return soldFilter && roomFilter && budgetFilter && areaFilter
      })
    },
    paginatedAndFilteredApartments() {
      return this.filteredApartments.slice(0, this.lastDisplayedIndex)
    },
    canLoadMore() {
      return this.lastDisplayedIndex < this.filteredApartments.length
    },
  },
  methods: {
    loadMore() {
      this.currentPage += 1
    },
    handleHideSoldChange(val) {
      this.filters.hideSold = val
    },
  },
}
